<template>
  <div class="wrapper" :style="{ backgroundImage: `url(${wrapperBgc})` }">
    <div class="header">
      <div class="logo">
        <img :src="logoImg" width="60" />
      </div>
      <div class="info-item">
        <img :src="tgImg" height="32" @click="handleToWrapLink(1)" />
        <img :src="serviceLogo" height="32" @click="handleToWrapLink(2)"  />
        <img :src="businessImg" height="32" @click="handleToWrapLink(3)" />
      </div>
    </div>
    <div class="content">
      <!-- :style="{ backgroundImage: `url(${contentBgc})` }" -->
      <img :src="contentBgc" width="100%" height="100%" />
    </div>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import imageURLDecrypt from "@/imageURLDecrypt.js";

export default {
  data() {
    return {
      wrapperBgc: "",
      contentBgc: "",
      logoImg: "",
      tgImg: "",
      serviceLogo: "",
      businessImg: "",
      grouplink: "https://t.me/xhsgo",
      serviceLink: 'https://chat.chatra.io/?isModern=true&NXdc=DSAD5wdTsRE#hostId=HuzJ3rhwFb5LxdsK3&isModern=true&NXdc=DSAD5wdTsRE',
      businessLink: 'https://t.me/Rolls_me',
      shanwulink: "https://t.me/Rolls_me",
      app_download_url: "https://yqntr.net/",
    };
  },
  async mounted() {
    this.wrapperBgc = await imageURLDecrypt(
      `https://m7bi82r.xpx93mjr.ink/image/2bo/fh/1x/1e3/f2f519d588825c84fb90efb603518632.webp`
    );
    this.contentBgc = await imageURLDecrypt(
      `https://m7bi82r.xpx93mjr.ink/image/155/2o0/35b/293/9ccd965380435c8aa69fbdaca26c362d.webp`
    );
    this.logoImg = await imageURLDecrypt(
      `https://m7bi82r.xpx93mjr.ink/image/2n5/283/2ld/24j/59f6b1c8897f4912f6b1af58ce3986f2.webp`
    );

    this.tgImg = await imageURLDecrypt(
      `https://m7bi82r.xpx93mjr.ink/image/wo/2bc/2yn/1rq/c92f5704d6c10ce56f0a8bc5a3c307f9.webp`
    );
    this.serviceLogo = await imageURLDecrypt(
      `https://m7bi82r.xpx93mjr.ink/image/gv/2tv/z9/f2/6772ecf4ce0435db2ae9ad27c31de13c.webp`
    );
    this.businessImg = await imageURLDecrypt(
      `https://m7bi82r.xpx93mjr.ink/image/2zq/268/2kz/1qq/7a864362ff34859770caef6a2d48fd7b.webp`
    );
  },
  props: {
    config: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    QrcodeVue,
  },
  methods: {
    handleToWrapLink(idx){
      if(idx === 1) {
          window.open(this.grouplink, "_blank");
      }
      if(idx === 2) {
          window.open(this.serviceLink, "_blank");
      }
      if(idx === 3) {
          window.open(this.businessLink, "_blank");
      }
    },
  },
  created() {
    this.app_download_url = "https://yqntr.net";
  },
};
</script>
<style lang="scss">
.wrapper {
  height: 100vh;
  overflow: hidden;
  position: relative;
  width: 100vw;
  // background: url(../img/bg.c5c7455b.png) no-repeat;
  background-size: 100% 100%;
  // background-position: cover;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .header {
    margin-top: 40px;
    padding: 0 40px;
    height: 60px;
    display: flex;
    justify-content: space-between;
    .info-item {
      display: flex;
      gap: 32px;
      cursor: pointer;
    }
  }
  .content {
    height: 802px;
    width: 1484px;
    position: absolute;
    bottom: 48px;
    top: 11vh;
    left: 50%;
    background-size: 100% 100%;
    background-position: cover;
    transform: translateX(-50%);
  }
}
</style>
